import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SvgIconModule } from '../svg-icon';

import { GeoSearchComponent } from './geo-search.component';
import { AutoCompleteModule } from '../auto-complete/auto-complete.module';
import { LoadingComponentModule } from '../loading/loading.module';


@NgModule({
    declarations: [GeoSearchComponent],
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
        AutoCompleteModule,
        LoadingComponentModule,
    ],
    exports: [
        GeoSearchComponent
    ]
})
export class GeoSearchModule { }
